import { Button } from '@strata/react-buttons';
import { FieldArray } from 'formik';
import PropTypes from 'prop-types';

import { MedDirection } from 'components/MedDirection';

export const MedDirectionList = ({ directions }) => (
    <FieldArray
        name="directions"
        render={(arrayHelpers) => (
            <div className="margin__bottom--large">
                {directions.map((direction, index) => (
                    <MedDirection key={direction.key} index={index} arrayHelpers={arrayHelpers} />
                ))}
                <Button
                    label="Add Direction"
                    onClick={() =>
                        arrayHelpers.push({
                            key: directions.length,
                            option: '',
                            value: 0,
                            dose_modifier: '',
                            strength: 0,
                            strength_uom: '',
                        })
                    }
                />
            </div>
        )}
    />
);

MedDirectionList.propTypes = {
    directions: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.number.isRequired,
            option: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
            dose_modifier: PropTypes.string,
            strength: PropTypes.number.isRequired,
            strength_uom: PropTypes.string.isRequired,
        }),
    ).isRequired,
};
